<template>
  <div class="pie-wrapper">
    <div class="circle-wrapper" v-if="hasVotes">
      <svg viewBox="0 0 64 64" class="pie">
        <circle
          v-for="(item, i) in items"
          :key="i"
          r="25%"
          cx="50%"
          cy="50%"
          :style="
            `stroke-dasharray: ${
              item.percentage == 0 ? item.percentage : item.percentage + 0.5
            } 100; stroke: ${item.color}; stroke-dashoffset: ${calculateOffset(
              i
            )}`
          "
        />
      </svg>
    </div>
    <div class="circle-wrapper" v-else>
      <svg viewBox="0 0 64 64" class="pie">
        <circle r="25%" cx="50%" cy="50%" stroke="#c5cdd4" stroke-width="3" fill="red" />
      </svg>
    </div>
    <div class="legend-wrapper" v-if="shouldShowLegend">
      <div class="legend">
        <span class="legend-item-wrapper" v-for="(item, index) of items" :key="index">
          <span class="legend-item" :style="{ 'background-color': item.color }"></span>
          <span
            class="legend-item-text"
            v-if="hasVotes"
            :class="{highlighted: item.id == highlightedOption}"
          >{{ item.label }} - {{ item.percentage }}%</span>
          <span class="legend-item-text" v-else>{{ item.label }} - 0%</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    animated: {
      type: Boolean,
      default: false
    },
    shouldShowLegend: {
      type: Boolean,
      default: true
    },
    highlightedOption: {
      type: String,
      default: null
    }
  },
  computed: {
    hasVotes() {
      let totalSum = 0;
      this.items.forEach(el => (totalSum += el.percentage));
      return totalSum === 0 ? false : true;
    }
  },
  created() {
    if (this.animated) {
      let originalItems = this.items.map(el => ({ ...el }));
      for (let i = 0; i < originalItems.length; i++) {
        this.items[i].percentage = -0.5;
      }
      setTimeout(() => {
        for (let i = 0; i < originalItems.length; i++) {
          this.items[i].percentage = originalItems[i].percentage;
        }
      }, 10);
    }
  },
  methods: {
    calculateOffset(i) {
      if (i == 0) {
        return 0;
      }
      let offset = 0;
      for (let j = 0; j < i; j++) {
        offset -= this.items[j].percentage;
      }
      return offset;
    }
  }
};
</script>

<style lang="scss">
.pie-wrapper {
  display: inline-flex;
  width: 100%;
}

.pie {
  // width: 230px;
  background: transparent;
  border-radius: 50%;
}
.pie circle {
  fill: none;
  stroke-width: 32;
  transition: stroke-dasharray 1s, stroke-dashoffset 1s;
}

.pie .circle-wrapper {
  width: 160px;
  min-width: 160px;
}

.legend-wrapper {
  position: relative;
  margin-left: 12px;
  .legend {
    display: flex;
    flex-direction: column;
  }
}

.legend-item-wrapper {
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  margin: 0.5em;
  // width: 150px;
}
.legend-item {
  height: 1.25em;
  width: 1.25em;
  border-radius: 2px;
  margin-right: 0.5em;
  background-color: var(--primary-color);
}

.legend-item-text.highlighted {
  font-weight: 600;
}
</style>
